<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadData"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="container">

          <div style="text-align: left">
            <div><span style="color:#606266">资产名称：</span> {{ item.Name }}</div>
            <div><span style="color:#606266">流程ID：</span> {{ item.ProcessName }}</div>
            <div><span style="color:#606266">业务系统：</span> {{ item.buSystem }}</div>
            <div><span style="color:#606266">创建人：</span> {{ item.CreatorUser }}</div>
            <div><span style="color:#606266">修改时间：</span> {{ item.CreationTime }}</div>
          </div>
          <div>
            <van-button type="success" size="small" @click="showDialog(item)">更新资产</van-button>
          </div>
        </div>
      </van-cell>
    </van-list>
  </van-pull-refresh>
  <van-dialog v-model:show="iShowDialog" title="更新资产" show-cancel-button :show-confirm-button="false" width="800">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
            v-model="editData.ProcessName"
            name="流程ID"
            label="流程ID"
            placeholder="流程ID"
            readonly
        />
        <van-field
            v-model="editData.buSystem"
            name="业务系统"
            label="业务系统"
            placeholder="业务系统"
            readonly
        />
        <van-field
            v-model="editData.Username"
            name="系统账号"
            label="系统账号"
            placeholder="系统账号"
            :rules="[{ required: true, message: '请填写系统账号' }]"
        />
        <van-field
            v-model="editData.Password"
            type="password"
            name="系统密码"
            label="系统密码"
            placeholder="系统密码"
            :rules="[{ required: true, message: '请填写系统密码' }]"
        />
        <van-field
            v-model="editData.Description"
            name="资产描述"
            label="资产描述"
            placeholder="资产描述"
            :rules="[{ required: true, message: '请填写资产描述' }]"
        />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>

  </van-dialog>

</template>

<script>

import {defineComponent, ref} from "vue";
import {List, Cell, Button, Dialog, Field, CellGroup, Form, Notify, showNotify, PullRefresh} from 'vant'
import 'vant/lib/index.css'
import Qs from "qs";
import {VXETable} from "vxe-table";


export default {
  name: "ProcessAsset",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Notify.name]: Notify,
    [PullRefresh.name]: PullRefresh
  },
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(20)
    const totalResult = ref(0) //总数量
    const iShowDialog = ref(false)
    const refreshing = ref(false);
    const editData = ref({
      'Id': '',
      'ProcessName': '',
      'buSystem': '',
      'Username': '',
      'Password': '',
      'Description': '',
      'OCAssetId': '',
      'Name': '',
      'Creator': '',
      'ProcessType': '',
      'ValueType':''
    })
    return {
      list,
      loading,
      finished,
      currentPage,
      pageSize,
      totalResult,
      iShowDialog,
      refreshing,
      editData,
    }
  },
  methods: {
    showDialog(item) {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 0,
        'pageSize': 0,
        'searchKey': [item.Id]
      };
      this.$api.assetManageAPI.getOneAsset(Qs.stringify(params))
        .then(res => {
          if (res.data.Success === false) {
            showNotify({type: 'danger', message: res.data.Message});
            return;
          }
          this.editData.Id = item.Id;
          this.editData.ProcessName = item.ProcessName;
          this.editData.buSystem = item.buSystem;
          this.editData.Description = item.Description;
          this.editData.Username = res.data.Data.Username;
          this.editData.Password = '';
          this.editData.OCAssetId = item.OCAssetId;
          this.editData.Name = item.Name;
          this.editData.ProcessType = item.ProcessType;
          this.editData.Creator = this.$store.state.userID;
          this.editData.ValueType = item.ValueTypeCode;
          this.iShowDialog = true

        })
        .catch(error => {
          console.log(error);
        })


    },
    loadData() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false;
      }
      if (this.totalResult === 0 || this.list.length === 0) {
        this.currentPage = 1;
      } else {
        if (this.currentPage < Math.ceil(this.totalResult / this.pageSize)) {
          this.currentPage++
        }
      }

      // 模拟异步加载数据
      this.loading = true;
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.currentPage,
        'pageSize': this.pageSize,
        'searchKey': ['', '','1'] //1 表示手机查询
      };
      this.$api.assetManageAPI.getAssetListMobile(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              showNotify({type: 'danger', message: res.data.Message});
              return;
            }
            this.totalResult = res.data.Data.totalResult;
            for (const row of res.data.Data.dataTable) {
              this.list.push({
                'Id': row.Id,
                'Name': row.Name,
                'buSystem': row.buSystem,
                'Description': row.Description,
                'ValueTypeCode': row.ValueTypeCode,
                'ValueName': row.ValueName,
                'ProcessName': row.ProcessName,
                'RobotName': row.RobotName,
                'AssetSet': row.AssetSet,
                'CreatorUser': row.CreatorUser,
                'CreationTime': row.CreationTime,
                'OCAssetId': row.OCAssetId,
                'ProcessType': row.ProcessType,
                'LastModificationTime': row.LastModificationTime

              })
            }

            if (this.list.length == res.data.Data.totalResult) {
              this.finished = true;
            }
            this.loading = false;

          })
          .catch(error => {
            console.log(error);

          })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.loadData();
    },
    onSubmit() {
      const data = this.editData;
      //更新资产
      this.$api.assetManageAPI.refreshAssetMobile(Qs.stringify(data))
          .then(res => {
            if (res.data.Success == false) {
              showNotify({type: 'danger', message: res.data.Message});
              return;
            }
            showNotify({type: 'success', message: '更新成功'});
            //借用写日志
            this.$api.websiteManageAPI.setLoginLog(Qs.stringify({
              'user': this.$store.state.userName,
              'msg': '咚咚更新资产['+data.Name+']成功',
              'type': 'Update'
            }));
            this.iShowDialog = false;
          })
          .catch(error => {
            showNotify({type: 'danger', message: error});
            console.log(error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
